import {
    DEV_AUTH
} from "./mutations";

const state = {
    dev_authenticated: false,
};
const getters = {
    is_dev_authenticated: state => {
        return state.dev_authenticated;
    }
};
const mutations = {
    [DEV_AUTH](state) {
        state.dev_authenticated = true;
    }
};

const actions = {
    async try_dev_auth({ commit }, data) {
        return new Promise((resolve, reject) => {
            if (state.dev_authenticated) reject({ error: "already_authenticated" });
            let params = { dev_token: data.dev_token, app_id: "vetvise.homepage" };
            let callable = firebase.app().functions("europe-west1").httpsCallable("Dev_Authentication");
            callable(params).then(result => {
                if (result.data.allowed === true) {
                    commit(DEV_AUTH, {});
                    resolve();
                } else reject({ error: "could_not_authenticate" });
            });
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
